export default "/_next/static/chunks/fonts/OpenSans-SemiBold-latin-aed3a7f3ac183b174b665807fc4497c4.woff2";